import {
  LOAD_CAMPAIGN_ANALYTICS,
} from './constants';

export function loadCampaignAnalytics(data) {
  return {
    type: LOAD_CAMPAIGN_ANALYTICS,
    data,
  };
}



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-analytics/actions.js
 **/